<div *ngIf="isLoading" class="{{(isLoading) ? 'loadingOverlay' : ''}}">
  <p-progressSpinner [style]="{height: '1.875rem', width: '1.875rem'}" strokeWidth="7" animationDuration="0.5s">
  </p-progressSpinner>
</div>
<div class="drive-attendance">
  <div class="attendance-wrapper" *ngIf="roundData?.length && driveStatus === 'Ongoing'">
    <div class="round-sidebar">
      <div *ngFor="let info of roundData" class="info-list"
        [ngClass]="{'selectedInfo': selectedRound?.event_id === info.event_id}" (click)="onRoundSelect(info)">
        <div class="img-label">
          <span>{{ roundTypesLabel[info.round_type] }}</span>
        </div>
      </div>
    </div>

    <p-card *ngIf="selectedRound" class="panel-card">
      <span class="att-title">
        Attendance Configuration - {{ roundTypesLabel[selectedRound.round_type] }}
      </span>

      <div class="config-content-wrapper">
        <div class="settings-column">
          <div class="section-card">
            <h3>Enable GPS Lock?</h3>
            <p-divider></p-divider>
            <div class="gps-lock-cont">
              <div class="flex items-center">
                <p-radioButton name="gpsLock" value="enabled" [(ngModel)]="gpsLockStatus" inputId="gpsLockStatusYes"
                  (ngModelChange)="lockTypeChange()" [disabled]="generatingQR" />
                <label for="gpsLockStatusYes">Yes</label>
              </div>
              <div class="flex items-center">
                <p-radioButton name="gpsLock" value="disabled" [(ngModel)]="gpsLockStatus" inputId="gpsLockStatusNo"
                  (ngModelChange)="lockTypeChange()" [disabled]="generatingQR" />
                <label for="gpsLockStatusNo">No</label>
              </div>
            </div>
          </div>

          <div *ngIf="gpsLockStatus === 'enabled'" class="section-card">
          <span class="instruction-cont">
            <h3>GPS Lock Settings</h3>
            <h3 (click)="openInstruction()" style="color: var(--blue-500);">
              <u>View Instructions</u>
            </h3>
          </span>
            <p-divider></p-divider>
            <div class="gps-lock-cont">
              <div class="flex items-center">
                <p-radioButton name="gpsFetchMode" value="auto" [(ngModel)]="gpsFetchMode" inputId="gpsFetchModeAuto"
                  (ngModelChange)="stopGeneration()" [disabled]="generatingQR" />
                <label for="gpsFetchModeAuto">Use Current Location</label>
              </div>
              <div class="flex items-center">
                <p-radioButton name="gpsFetchMode" value="manual" [(ngModel)]="gpsFetchMode"
                  inputId="gpsFetchModeManual" (ngModelChange)="stopGeneration()" [disabled]="generatingQR" />
                <label for="gpsFetchModeManual">Enter Manually</label>
              </div>
            </div>

            <div class="fetch-mode-cont">
              <div *ngIf="gpsFetchMode === 'auto'" class="gps-auto-cont">
                <div class="coordinate-cont">
                  <button (click)="fetchLocationWithStrategy()" class="p-button-create blue-outlined-btn qr-button"
                    [disabled]="generatingQR || fetchingLocation">
                    <i class="pi pi-map-marker"></i>
                    {{fetchingLocation ? 'Fetching Location...' : 'Fetch Location'}}
                  </button>
                  <div *ngIf="gpsLock.lat && gpsLock.lng" class="gps-lock-info">
                    📍 {{ gpsLock.lat }}, {{ gpsLock.lng }}
                  </div>
                  <!-- <small class="gps-note">
                    Note: GPS accuracy may vary based on device settings, signal strength, and environmental factors.
                  </small> -->
                </div>

                <div class="allowed-radius-cont">
                  <label>Allowed Radius (m):</label>
                  <input [(ngModel)]="allowedRadius" type="number" (ngModelChange)="stopGeneration()"
                    [disabled]="generatingQR" />
                </div>
              </div>

              <div *ngIf="gpsFetchMode === 'manual'" class="gps-auto-cont">
                <div class="allowed-radius-cont">
                  <label>Lat:</label>
                  <input [(ngModel)]="gpsLock.lat" inputId="lat" type="number" (ngModelChange)="stopGeneration()"
                    [disabled]="generatingQR" />
                </div>
                <div class="allowed-radius-cont">
                  <label>Lng:</label>
                  <input [(ngModel)]="gpsLock.lng" inputId="lng" type="number" (ngModelChange)="stopGeneration()"
                    [disabled]="generatingQR" />
                </div>
                <div class="allowed-radius-cont">
                  <label>Allowed Radius (m):</label>
                  <input [(ngModel)]="allowedRadius" type="number" (ngModelChange)="stopGeneration()"
                    [disabled]="generatingQR" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="qr-column">
          <div class="section-card">
            <h3>QR Code</h3>
            <p-divider></p-divider>
            <div class="qr-code-container">
              <button (click)="startQRCodeProcess()" [disabled]="!canGenerateQR() || generatingQR"
                class="p-button-create blue-filled-btn qr-button">
                <i class="pi pi-qrcode"></i>
                Save & Generate QR
              </button>

              <button (click)="stopGeneration()" [disabled]="!generatingQR || isQrInAnotherTab"
                class="p-button-create red-outlined-btn qr-button">
                <i class="pi pi-stop-circle"></i>
                Stop
              </button>
            </div>

            <div *ngIf="qrCodeUrl && !isQrInAnotherTab" class="qr-container">
              <img id="qrImage" [src]="qrCodeUrl" alt="QR Code" (click)="openQRInFullscreen()" class="qr-image" />
              <div class="qr-actions">
                <button (click)="openQRInFullscreen()" class="action-buttons" pTooltip="Open in fullscreen"
                  tooltipPosition="top">
                  <i class="pi pi-window-maximize"></i>
                </button>
                <button (click)="openQRInNewTab()" class="action-buttons" pTooltip="Open in new tab"
                  tooltipPosition="top">
                  <i class="pi pi-external-link"></i>
                </button>
              </div>
              <p class="refresh-text">
                ♻️ Refreshing in {{ nextRefreshIn }}s
              </p>
            </div>

            <div class="qr-container" *ngIf="isQrInAnotherTab">
              <span>
                The QR code is now displayed in a new tab. Close that tab to stop the QR generation process.
              </span>
            </div>

            <div *ngIf="generatingQR && !qrCodeUrl" class="qr-container">
              <div class="qr-loader">
                <p-progressSpinner [style]="{height: '1.875rem', width: '1.875rem'}" strokeWidth="7"
                  animationDuration="0.5s">
                </p-progressSpinner>
                <p class="loading-text">Generating secure QR Code...</p>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="attendance-table-header">
        <h3 class="table-section-heading">Students with Recorded Attendance</h3>

        <div class="refresh-controls">
          <div class="auto-refresh-toggle">
            <p-checkbox [(ngModel)]="autoRefresh" [binary]="true" inputId="autoRefreshToggle"
              (ngModelChange)="handleAutoRefreshToggle()"></p-checkbox>
            <label for="autoRefreshToggle">Auto-refresh every 10s</label>
          </div>
          <button (click)="fetchStudentList()" class="p-button-create blue-outlined-btn qr-button"
            [disabled]="autoRefresh">
            <i class="pi pi-refresh"></i>
            Refresh
          </button>
        </div>
      </div>

      <p-divider></p-divider>

      <div class="table-cont table-relative programme-offered-table">
        <div *ngIf="fetchingStudents && !isLoading" class="{{(fetchingStudents) ? 'loadingOverlay' : ''}}">
          <p-progressSpinner [style]="{height: '1.875rem', width: '1.875rem'}" strokeWidth="7" animationDuration="0.5s">
          </p-progressSpinner>
        </div>
        <app-table [isLoading]="isLoading" [columns]="columns" [dataList]="dataList" [dataCount]="dataCount"
          [pageLimits]="pageLimits" [captionsList]="captionsList" [tableheight]="tableHeight" [totalPage]="totalPage"
          [isShowSelectedAll]="true" [showDownload]="true" (search)="searchValueChange($event)"
          [actionToSelect]="actionOptions" (sortBy)="sortChange($event)" (rowLength)="rowLengthChange($event)"
          (pageNo)="pageChange($event)" searchBy="Email / Registration Number"
          (additionalOptionChange)="revokeOptionChange($event)" (downloadEvent)="downloadCustomField()"
          [additionalOptions]="additionalOptions" (tableActionClick)="tableAction($event)"></app-table>
      </div>
    </p-card>
  </div>
  <div class="attendance-status-box" *ngIf="!isLoading">
    <div *ngIf="driveStatus !== 'Ongoing'" class="status-message error">
      <i class="pi pi-ban"></i>
      Attendance cannot be configured as the drive is not ongoing.
    </div>

    <div *ngIf="driveStatus === 'Ongoing' && !roundData?.length" class="status-message warning">
      <i class="pi pi-info-circle"></i>
      There are no rounds available to configure attendance.
    </div>
  </div>

  <p-sidebar class="download-sidebar" [(visible)]="showDownload" position="right" (onHide)="clearInputs()"
    [dismissible]="false">
    <ng-template pTemplate="header">
      <div class="header-cont">
        <span>Download Attendance Data</span>
        <div class="flex gap-10">
          <button pbutton class="p-button-create blue-filled-btn" (click)="downloadFields()" type="submit"
            label="Save">Download
          </button>
        </div>
      </div>

    </ng-template>
    <ng-template pTemplate="body">
      <div class="sidebar-body">
        <div class="radioButton-group">
          <span>Download as</span>
          <div class="radioButton">
            <p-radioButton value="excel" inputId="excel" [(ngModel)]="downloadColumnAs">
            </p-radioButton>
            <label for="excel"
              [style]="{color: downloadColumnAs === 'excel' ? 'var(--clr-primary)' : 'var(--fc-light-dark)'}"><em
                class="pi pi-file"></em>Excel</label>
          </div>
          <div class="radioButton">
            <p-radioButton value="csv" inputId="csv" [(ngModel)]="downloadColumnAs">
            </p-radioButton>
            <label for="csv"
              [style]="{color: downloadColumnAs === 'csv' ? 'var(--clr-primary)' : 'var(--fc-light-dark)'}"><em
                class="pi pi-file-excel"></em>CSV</label>
          </div>
        </div>


        <div *ngFor="let category of downloadCategories; let i = index" class="fields-container">
          <div class="title-box">
            <span>{{category.header}}</span>
          </div>

          <div *ngIf="category.data.length">
            <div class="selectAll-checkbox field-checkbox" *ngIf="category.type !== 'resume'">
              <p-checkbox [binary]="true" (onChange)="selectAllDownloadData(i)"
                [(ngModel)]="category.isSelectedAll"></p-checkbox>
              <span>Select All</span>
            </div>

            <div class="fields">
              <div *ngFor="let field of category.data" class="field-checkbox">
                <p-checkbox [binary]="true" [(ngModel)]="field.active" (onChange)="onDropDownChange(i)">
                </p-checkbox>
                <label [for]="field.label">{{ field.label }}</label>
              </div>
            </div>
          </div>

          <ng-template #noDataTemplate>
            <div *ngIf="!category || !category.data || !category.data.length" class="no-data">
              <span>No Fields available</span>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-template>
  </p-sidebar>

  <p-dialog header="Header" [resizable]="false" [draggable]="false" [modal]="true" [(visible)]="displayRevokeReason"
    [style]="{ width: '30vw' }" (onHide)="onDialogClose()" [draggable]="false">
    <div *ngIf="fetchingStudents" class="{{(fetchingStudents) ? 'loadingOverlay' : ''}}">
      <p-progressSpinner [style]="{height: '1.875rem', width: '1.875rem'}" strokeWidth="7" animationDuration="0.5s">
      </p-progressSpinner>
    </div>
    <ng-template pTemplate="header">
      <span class="text-xl font-bold header">Revoke Reason</span>
    </ng-template>
    <p>
      Please enter the reason for revoking the attendance:
    </p>

    <textarea [(ngModel)]="revokeReason" class="p-inputtext p-component rejection-textarea"
      placeholder="Type revoke reason here..."></textarea>

    <ng-template pTemplate="footer">
      <button pButton class="p-button-create blue-filled-btn" (click)="revokeStudents()">
        Confirm
      </button>
    </ng-template>
  </p-dialog>

  <p-dialog header="Instructions" [resizable]="false" [draggable]="false" [modal]="true"
  [(visible)]="isInstructionDialogOpen" [style]="{ width: '30vw' }" (onHide)="isInstructionDialogOpen = false">
  
  <ng-template pTemplate="header">
    <span class="text-xl font-bold header">Instructions for GPS Lock</span>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="instruction-content">
      <p>
        The GPS location fetched may not always be perfectly accurate. Accuracy can vary due to a number of factors, including:
      </p>
      <ul>
        <li>Weak or unstable GPS signal (especially indoors)</li>
        <li>Device-specific limitations</li>
        <li>Environmental obstructions like buildings or trees</li>
        <li>Disabled or restricted location permissions</li>
      </ul>

      <p>
        If you notice significant discrepancies or unusually high deviation in the fetched location, we recommend using the 
        <strong>“Enter Manually”</strong> option to input the coordinates directly.
      </p>

      <p>
        For more technical details on how GPS accuracy works, refer to this article:
        <a href="https://developer.mozilla.org/en-US/docs/Web/API/Geolocation_API" target="_blank" rel="noopener noreferrer">
          MDN Web Docs – Geolocation API
        </a>
      </p>
    </div>
  </ng-template>
</p-dialog>

</div>